import styles from '@features/campaigns/list/components/Table/CampaignsListTable.module.scss';
import { Campaign } from '@shared/utils/interfaces/campaign';

function AdvertiserColumnBodyTemplate(campaign: Campaign) {
  return <span className={styles.columnValues}>{campaign.advertiser?.name}</span>;
}

export default AdvertiserColumnBodyTemplate;
